import { Children, PropsWithChildren, useEffect } from 'react';

import { Grid2 } from '@mui/material';

import { LoadingDetailsBlock } from '~components';

interface DetailsGridLayoutProps extends PropsWithChildren {
	isLoading?: boolean;
	maxHeight?: number | string;
}

const DetailsGridLayout = ({ isLoading, children, maxHeight = 600 }: DetailsGridLayoutProps) => {
	if (isLoading) {
		return (
			<Grid2 container spacing={3}>
				{Children.toArray(children).map((_, i) => (
					<Grid2 key={i} size={{ xs: 12, md: 6, lg: 6, xl: 4 }} maxHeight={600}>
						<LoadingDetailsBlock key={i} />
					</Grid2>
				))}
			</Grid2>
		);
	}

	return (
		<Grid2 container spacing={3}>
			{Children.map(
				children,
				(child, i) =>
					child != null && (
						<Grid2 key={i} size={{ xs: 12, md: 6, lg: 6, xl: 4 }} maxHeight={maxHeight}>
							{child}
						</Grid2>
					)
			)}
		</Grid2>
	);
};

export default DetailsGridLayout;
